import { render } from "./VPNUser.vue?vue&type=template&id=4d67a664"
import script from "./VPNUser.vue?vue&type=script&lang=js"
export * from "./VPNUser.vue?vue&type=script&lang=js"

import "./VPNUser.vue?vue&type=style&index=0&id=4d67a664&lang=scss"

import exportComponent from "/opt/app-root/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__